// extracted by mini-css-extract-plugin
export default {"Insight":"_Insight--rNVWc","Date":"_Date--NBZ76"};